import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

interface LogCompleteEditCoverImageParams {
  sno: number;
  name?: string | null;
  likesCount?: number | null;
  favoritesCount?: number | null;
}

export const useLogCompleteEditFolderCoverImage = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ sno, name, likesCount, favoritesCount }: LogCompleteEditCoverImageParams) => {
      logAnalyticsEvent({
        name: 'COMPLETE_EDIT_FOLDER_COVER_IMAGE',
        analytics: {
          FOLDER_SNO: sno.toString(),
          FOLDER_NAME: name,
          FOLDER_TYPE: '제작서랍',
          LIKES_COUNT: likesCount,
          FAVORITES_COUNT: favoritesCount,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
